import React from 'react'
import {Autocomplete, TextField, Chip} from '@mui/material'

export default function SelectionAutocomplete({options = [], selected = [], handleSelectionChange, maxVisibleOptions = 4}) {
  return (
    <Autocomplete
      multiple
      options={options}
      value={options.filter((o) => selected.includes(o.value))}
      onChange={(_, newValue) => handleSelectionChange(newValue.map((v) => v.value))}
      getOptionLabel={(o) => o.label || ''}
      isOptionEqualToValue={(o, v) => o.value === v.value}
      disableCloseOnSelect
      renderTags={(value, getTagProps) =>
        value.map((option, index) => (
          <Chip
            color='primary'
            label={option.label}
            size='small'
            {...getTagProps({index})}
            key={option.value}
          />
        ))
      }
      renderInput={(params) => (
        <TextField {...params} placeholder='Search and select...' size='small' />
      )}
    />
  )
}
